"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternalLink = isExternalLink;

function isExternalLink(link, location) {
  if (!link) return false;
  return link.replace('https://', '').replace('http://', '').indexOf(location.hostname) !== 0 && !link.match(/^\/[^/]/);
}